const _excluded = ["children", "tabIndex", "disabled", "onClick", "overrideClassName", "role", "as"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { cx } from "../../helpers/utils/cx";
function GhostButton(_ref, ref) {
  let {
      children,
      tabIndex = 0,
      disabled = false,
      onClick,
      overrideClassName,
      role = "button",
      as: Component = "div"
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const onKeyDown = React.useCallback(event => {
    if (event.key === "Enter" || event.key === " ") {
      onClick(event);
    }
  }, [onClick]);
  return /*#__PURE__*/React.createElement(Component, _extends({
    role: role,
    "aria-disabled": disabled,
    tabIndex: tabIndex,
    onClick: disabled ? undefined : onClick,
    onKeyDown: disabled ? undefined : onKeyDown,
    className: cx("inline-block", "cursor-pointer", "active:scale-975 active:ease-in-out active:duration-100", disabled && "pointer-events-none", overrideClassName),
    ref: ref
  }, props), children);
}
const ForwardedGhostButton = /*#__PURE__*/React.forwardRef(GhostButton);
export { ForwardedGhostButton as GhostButton };